import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=4737b48e&scoped=true&"
import script from "./ProjectPage.vue?vue&type=script&lang=js&"
export * from "./ProjectPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=4737b48e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4737b48e",
  null
  
)

export default component.exports